module.exports = __webpack_public_path__ + "img/marketing-explore.9eb9a089.jpg";